export const defaultLocale = 'en';

export const locales = ['en', 'fr', 'es', 'de'] as const;
